export { SysqueTextBoxDescriptionModule } from './sysque-text-area-description.module';
export { SysqueTextBoxDescriptionComponent } from './sysque-text-area-description.component';